﻿module.exports = function ($) {
    return {
        init: function () {
            $("#RegisterForm input").on("keyup", function (e) {
                if (e.keyCode === 13) {
                    $("#RegisterForm").submit();
                }
            });
        }
    }
} 